import React from 'react';
import { useViewMode } from 'app/shared/hooks/useViewMode';
import { emitTrackToggleViewModeEvent } from 'app/shared/models/Clickstream/ListingsClickstreamEvents';
import ListIcon from './ListIcon';
import { FeedIcon } from 'app/shared/halo/components/ui/icons';
import { container, iconStyle, toggleButtonActive, toggleButtonInactive, toggleGroup } from './viewModeToggle.styles';

const ViewModeToggle = () => {
  const [viewMode, setViewMode] = useViewMode();

  return (
    <div className={container}>
      <div className={toggleGroup} role="group" aria-label="View mode">
        <button
          type="button"
          className={viewMode === 'grid' ? toggleButtonActive : toggleButtonInactive}
          onClick={() => {
            if (viewMode !== 'grid') {
              emitTrackToggleViewModeEvent({ targetView: 'list' });
              setViewMode('grid');
            }
          }}
          aria-pressed={viewMode === 'grid'}
          aria-label="List view"
        >
          <ListIcon className={iconStyle} />
          List
        </button>
        <button
          type="button"
          className={viewMode === 'feed' ? toggleButtonActive : toggleButtonInactive}
          onClick={() => {
            if (viewMode !== 'feed') {
              emitTrackToggleViewModeEvent({ targetView: 'feed' });
              setViewMode('feed');
            }
          }}
          aria-pressed={viewMode === 'feed'}
          aria-label="Feed view"
        >
          <FeedIcon className={iconStyle} />
          Feed
        </button>
      </div>
    </div>
  );
};

export default ViewModeToggle;
